import { Component, OnInit, Inject, EventEmitter, Output, LOCALE_ID } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { AdminGenericEdit } from '../models/admin.edit.interface';
import { GenericPageInfo } from '../models/generic.pageinfo.interface';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../models/generic.dialog.interface';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})

export class EditComponent implements OnInit {
  isRequesting: boolean;

  constructor(private adminService: AdminService, @Inject(LOCALE_ID) private locale: string,
    public dialogRef: MatDialogRef<EditComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }

  adminEdit: AdminGenericEdit;
  pageInfo: GenericPageInfo;
  errors: string;
  numbersList: number[];

  @Output() updated = new EventEmitter();
  @Output() canceled = new EventEmitter();

  ngOnInit() {
    {
      this.numbersList = [] as number[];
      for (let i = 1; i <= 99; i++) {
        this.numbersList.push(i);
      }

      console.log(this.data.action)

      if (this.data.id == null || this.data.id == 0) {
        this.adminEdit = {} as AdminGenericEdit;
        this.adminEdit.isActive = true;
        this.pageInfo = this.adminService.setGenericPageInfo(this.data.action, this.locale);
      }
      else {
        this.adminService.getEntity(this.data.action, this.data.id)
          .subscribe({
            next: (data) => {
              this.adminEdit = data;
              this.pageInfo = this.adminService.setGenericPageInfo(this.data.action, this.locale);
            }
          });
      }
    }
  }

  saveEntity(form: NgForm) {
    console.log('in generic onSubmit: ', this.adminEdit);

    this.errors = '';

    if (form.valid) {
      this.isRequesting = true;

      let dealerId = this.adminService.getDealerId();

      this.adminService.saveEntity(this.adminEdit, this.pageInfo.nextRoute, dealerId)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            if (result) {
              this.dialogRef.close();
              /*this.router.navigate(['/admin/list/' + this.pageInfo.nextRoute])*/;
            }
          },
          error: (error: string) => {
            this.errors = error;
          }
        });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

